import styled from 'styled-components';
import { color } from 'styled-system';
import { Button, colors, Drawer } from '@equinor/opt-ui-core';
import { boxElementsDimensions, customScreenSizes } from 'AppTheme/constants';
const { sidebarNavWidth } = boxElementsDimensions;
const { sidebarCommentsTrigger, sidebarNavTrigger } = customScreenSizes;
// Styled components
export const SidebarBase = styled(Drawer).attrs(({ smallScreenSize, width }) => ({
    smallScreenSize: smallScreenSize ?? sidebarNavTrigger,
    width: width ?? sidebarNavWidth
})) `
  ${color};
  display: ${({ display }) => display};
  @media only screen and (min-width: 1001px) {
    padding-top: 0;
  }
`;
export const ContainerSidebarBaseResetZIndex = styled.div `
  transform: translate(0px, 0px);
  > div {
    height: 100%;
    width: 100%;
  }
`;
export const ToggleButton = styled(Button) `
  width: 32px !important;
  min-width: 32px !important;
  height: 32px !important;
  min-height: 32px !important;
  border-radius: 4px !important;
  background-color: ${colors.slateblue} !important;
`;
export const SidebarToggleButton = styled(ToggleButton) `
  @media only screen and (min-width: ${sidebarNavTrigger + 1}px) {
    display: none;
  }
`;
export const SidebarSmallToggleButton = styled(ToggleButton) `
  @media only screen and (min-width: ${sidebarCommentsTrigger + 1}px) {
    display: none;
  }
`;
